export const h5pVideosData = [
    {
        name: "Dummy 1",
        path: "/h5p/content/v1"
    },
    {
        name: "Dummy 2",
        path: "/h5p/content/v2"
    }
]